import { WORDMARK } from "../content";

/** CarCost logo: a little car on a moving road. Wheels spin on hover (see .logo in styles.css). */
export function Logo() {
  return (
    <a className="logo" href="/">
      <svg className="logo-mark" viewBox="0 0 48 48" width="48" height="48" aria-hidden="true" focusable="false">
        <defs>
          <linearGradient id="logo-bg" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#10b981" />
            <stop offset="1" stopColor="#0ea5c6" />
          </linearGradient>
        </defs>
        <rect width="48" height="48" rx="13" fill="url(#logo-bg)" />
        <path
          d="M9 30h30v-4.2c0-1.3-.7-2.4-1.9-2.8l-4.6-1.7-3-4.4a2.6 2.6 0 0 0-2.1-1.1h-6.9a2.6 2.6 0 0 0-2.1 1.1l-3 4.4-4.6 1.7c-1.2.4-1.8 1.5-1.8 2.8z"
          fill="#fff"
        />
        <path d="M19.4 22l2.1-3.3h5l2.1 3.3z" fill="#0b6b52" opacity=".55" />
        <line
          className="logo-road"
          x1="9"
          y1="38"
          x2="39"
          y2="38"
          stroke="#fff"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeDasharray="4 4"
          opacity=".6"
        />
        {[16, 32].map((cx) => (
          <g key={cx} className="logo-wheel" style={{ transformOrigin: `${cx}px 31px` }}>
            <circle cx={cx} cy="31" r="5" fill="#0f2a3a" />
            <circle cx={cx} cy="31" r="3.3" fill="#fff" />
            <path d={`M${cx} 28.4v5.2M${cx - 2.6} 31h5.2`} stroke="#0f2a3a" strokeWidth="1.2" strokeLinecap="round" />
          </g>
        ))}
      </svg>
      <span className="wordmark">
        {WORDMARK.start}
        <span>{WORDMARK.end}</span>
      </span>
    </a>
  );
}
